"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _image = require("@site/pattern-library-core/image");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
const LifestyleWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LifestyleWrapper",
  class: "pl-l1v4srhz"
});
const Sticker = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Sticker",
  class: "pl-s1x8pmzp"
});
const ImageContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImageContainer",
  class: "pl-i18jlk7s"
});

/**
 * Render InspireLifestyle Component
 *
 * @param {Object} props React props
 * @param {String} props._name Section Tracking name
 * @param {Object} props.stickerMob Mobile Sticker Url and AltText
 * @param {Object} props.stickerDesk Desktop Sticker Url and AltText
 * @param {Object} props.imgMob Mobile Container Image Url and AltText
 * @param {Object} props.imgDesk Desktop Container Image Url and AltText
 * @param {Object} props.img4K 4K Container Image Url and AltText > 1200px Width
 * @param {string} props.verticalMargin Vertical Outer Spacing value
 * @param {string} props.verticalPadding Vertical Inner Spacing value
 * @returns {React.ReactElement} InspireLifestyle Component
 * @public
 */

function InspiredLifestyleSection({
  _name,
  stickerMob,
  stickerDesk,
  imgMob,
  imgDesk,
  img4K,
  verticalMargin = 'none',
  verticalPadding = 'small',
  ...rest
}) {
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    _name: _name,
    dataCy: "inspired-lifestyle-section",
    verticalMargin: verticalMargin,
    verticalPadding: verticalPadding
  }, /*#__PURE__*/_react.default.createElement(LifestyleWrapper, null, /*#__PURE__*/_react.default.createElement(Sticker, {
    "data-cy": "inspired-lifestyle-sticker"
  }, /*#__PURE__*/_react.default.createElement(_image.LazyPicture, (0, _extends2.default)({
    defaultSrc: stickerDesk?.url,
    defaultAltText: stickerDesk?.altText
  }, rest), /*#__PURE__*/_react.default.createElement("source", {
    srcSet: stickerMob?.url,
    media: `${_patternLibraryUtils.deviceMax.tabletLg}`
  }), /*#__PURE__*/_react.default.createElement("source", {
    srcSet: stickerDesk?.url,
    media: `${_patternLibraryUtils.device.laptop}`
  }))), /*#__PURE__*/_react.default.createElement(ImageContainer, {
    "data-cy": "inspired-lifestyle-background-image"
  }, /*#__PURE__*/_react.default.createElement(_image.LazyPicture, (0, _extends2.default)({
    defaultSrc: imgDesk?.url,
    defaultAltText: imgDesk?.altText
  }, rest), /*#__PURE__*/_react.default.createElement("source", {
    srcSet: imgMob?.url,
    media: `${_patternLibraryUtils.deviceMax.tabletLg}`
  }), /*#__PURE__*/_react.default.createElement("source", {
    srcSet: imgDesk?.url,
    media: `${_patternLibraryUtils.device.laptop}`
  }), /*#__PURE__*/_react.default.createElement("source", {
    srcSet: img4K?.url,
    media: `${_patternLibraryUtils.device.desktop}`
  })))));
}
var _default = exports.default = InspiredLifestyleSection;
InspiredLifestyleSection.propTypes = {
  stickerMob: _propTypes.default.object,
  stickerDesk: _propTypes.default.object,
  imgMob: _propTypes.default.object,
  imgDesk: _propTypes.default.object,
  img4K: _propTypes.default.object,
  ..._patternLibraryUtils.marginProps,
  ..._patternLibraryUtils.paddingProps
};